interface IBriefSelectionFilter {
  onChange: (filterString) => void
}
export function BriefFontSelectionFilter({ onChange }: IBriefSelectionFilter) {
  return (
    <div className="w-full mb-6 select-none">
      <input
        type="text"
        placeholder="Search Font..."
        className="w-full px-6 py-5 text-xl leading-none border rounded-lg outline-none bg-core-grey-20 placeholder-core-grey-70 text-core-grey-100 border-core-grey-20 focus:border-acai"
        onInput={(event) => onChange(event.currentTarget.value)}
      />
    </div>
  )
}
